import type { FaireProductEntity } from "../../entity_types/product";

export const p_75tn55twkd: FaireProductEntity = {
  token: "p_75tn55twkd",
  type: "product",
  name: "Mini Spa Rollers 2pc Set",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/5d9b68b52333b3c9315dad2a24ab616815ef9313f068fa16d9ff2355ba83b423.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76d7679b68cc78c18566b0e01b536f9b951d7b89ccdc8e2d9cf76e910b29f91a.jpeg",
    "https://cdn.faire.com/fastly/9b6751c51f055aee320a8f9c35028da5c7f538a6c664317f72b8e2524fdf1479.jpeg",
    "https://cdn.faire.com/fastly/ac61a869f0fcce7e6e5d36c66bea9be02bdf3a056ed2584a52b61f0f72e8a87e.jpeg",
    "https://cdn.faire.com/fastly/2f588c43ba4fcce91203e422804fab50486f8324e2b942c62377175231b90457.jpeg",
    "https://cdn.faire.com/fastly/969e96f4907d765da564d11e3284d12d488318ae09398a7df5e3c170f9f6a06b.jpeg",
    "https://cdn.faire.com/fastly/d9cd7c53a95dcc49621c824907eca71fde5805a373c3696d01f18e09bc8a6768.jpeg",
    "https://cdn.faire.com/fastly/27d5f4f9eab20f6636db554d9a2bf1e0884d1919058764d31b09bcde60d0b2af.jpeg",
    "https://cdn.faire.com/fastly/d15f7bb4c8203045d77a9d05017b5e34c27dcb8a9878d4b59539d78c9a2a5c9d.jpeg",
  ],
  priceDollars: 9,
  description:
    "Kitsch Mini Eye & Face Rollers take your routine to the next level and rejuvenate your skin with the perfect roller duo!\n\n**𝐁𝐞𝐧𝐞𝐟𝐢𝐭𝐬:**\n• Powerful benefits packed in a mini size - designed to fit into the small contours of your face & perfect for your delicate eye area\n• Silicone roller massages the skin and promotes healthy blood circulation & lymphatic drainage\n• Grooves in the silicone help to massage the skin and relieve stress & tension headaches\n• Smooth metal roller provides cooling effect and soothes tired, puffy eyes and inflammation\n• Use in combination with your favorite products to allow for deeper penetration and application\n• Includes a soft velvet pouch for easy storage or on-the-go luxury",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:38.231Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
